/**
 * GraphQL Query
 * 保留設定
 */

/**
 * 注文詳細(保留設定タブ)
 */
export const GRAPH_QL_QUERY_PENDING_LIST = `
  query {
    pendings (?) {
      id
      latestOrderRefid
      shipmentId
      pendingAt
      type
      pendReason
      unpendReason
      status
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`
